module.exports = __webpack_public_path__ + "assets/images/amira_action_success.6888fee099356747c0bd7fccfab4f44b.svg";